import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import createWorkDraftData from "astrid-firestore/src/api/works/createWorkDraftData";

import Flex from "../../../../components/Flex/Flex";
import { getItem, setItem } from "../../../../utils/localStorage";
import Button from "../../../ui/components/Buttons/Button";
import InstantSearch from "../../../ui/components/InstantSearch/InstantSearch";
import InstantSearchBox from "../../../ui/components/InstantSearch/InstantSearchBox";
import InstantSearchClear from "../../../ui/components/InstantSearch/InstantSearchClear";
import InstantSearchHits from "../../../ui/components/InstantSearch/InstantSearchHits";
import InstantSearchHitsPerPage from "../../../ui/components/InstantSearch/InstantSearchHitsPerPage";
import InstantSearchNumberOfHits from "../../../ui/components/InstantSearch/InstantSearchNumberOfHits";
import InstantSearchPagination from "../../../ui/components/InstantSearch/InstantSearchPagination";
import InstantSearchPresets from "../../../ui/components/InstantSearch/InstantSearchPresets";
import InstantSearchRefinements from "../../../ui/components/InstantSearch/InstantSearchRefinements";
import PageView from "../../../ui/views/PageView/PageView";

import { useOrganizationId } from "../../../organizations/state/organizationId";
import Table from "../../../tables/components/Table";

import WorkMetaDataEdit from "../../components/WorkMetaDataEdit/WorkMetaDataEdit";
import useWorksRefinements from "../../hooks/useWorksRefinements";
import useWorksTableColumns from "../../hooks/useWorksTableColumns";
import useWorksTableDropdownMenuOptions from "../../hooks/useWorksTableDropdownMenuOptions";

export default function WorksView({ publisher }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const organizationId = useOrganizationId();

	const columns = useWorksTableColumns();
	const refinements = useWorksRefinements({ publisher });
	const getDropdownMenuOptions = useWorksTableDropdownMenuOptions();

	const [workDraft, setWorkDraft] = useState(null);

	const presetsPath = `works-${publisher?.id || "admin"}`;

	const configure = {
		filters: publisher && `publisher.id:${publisher.id}`,
	};

	return (
		<InstantSearch routing indexName="works" configure={configure}>
			<PageView
				header={t("works", "Works")}
				extra={
					<Button primary onClick={() => setWorkDraft(createWorkDraftData({ publisher }))}>
						{t("createWork", "Create work")}
					</Button>
				}
				sidebar={
					<>
						<InstantSearchBox />

						<InstantSearchRefinements refinements={refinements} />
					</>
				}
			>
				<Flex gap={10} justifyContent="flex-start">
					<Flex gap={10} justifyContent="flex-start">
						<InstantSearchPresets path={presetsPath} refinements={refinements} />

						<InstantSearchClear />

						<InstantSearchNumberOfHits />
					</Flex>

					<InstantSearchHitsPerPage />
				</Flex>

				<InstantSearchHits>
					{({ data }) => (
						<Table
							data={data}
							columns={columns}
							enableColumnSelector
							onChangeVisibleColumns={(visibleColumns) => {
								return setItem(`columns.works.${organizationId}`, visibleColumns);
							}}
							visibleColumns={getItem(`columns.works.${organizationId}`)}
							getDropdownMenuOptions={getDropdownMenuOptions}
							onClick={({ id }) => navigate(id)}
						/>
					)}
				</InstantSearchHits>

				<InstantSearchPagination />
			</PageView>

			{workDraft && (
				<WorkMetaDataEdit work={workDraft} publisher={publisher} onClose={() => setWorkDraft(null)} />
			)}
		</InstantSearch>
	);
}
